<template>
  <OnboardingModalContent
    :title="$t('onboarding_profile_picture_subtitle')"
    data-testid="profile-picture-upload-step"
  >
    <div
      v-if="avatarUrlStored == null"
      class="tw-flex tw-flex-col tw-items-center tw-py-8"
    >
      <CameraIcon
        class="cursor-pointer"
        role="button"
        @click="openUploadCare"
      />
      <!-- eslint-disable vue/no-v-html -->
      <p
        data-testid="add-button"
        class="tw-text-gray-subtitle tw-cursor-pointer"
        @click="openUploadCare"
        v-html="$t('onboarding_profile_picture_choose_image_text')"
      />
      <!--eslint-enable-->
    </div>
    <div v-else>
      <div
        class="tw-w-28 tw-h-28 tw-mx-auto tw-rounded-full tw-my-4 tw-bg-cover"
        :style="{ backgroundImage: 'url(' + avatarUrlStored + ')' }"
      ></div>
      <div class="tw-flex tw-justify-center tw-my-4">
        <Button type="submit" @click="updateProfilePicture">{{
          $t('onboarding_save')
        }}</Button>
      </div>
    </div>
    <template #bottom>
      <BottomActions
        v-if="showBackButton"
        @left-action-click="$emit('prev')"
        @right-action-click="$emit('next')"
      />
      <BottomActions v-else @right-action-click="$emit('next')" />
    </template>
  </OnboardingModalContent>
</template>

<script>
import { mapState } from 'vuex'

import OnboardingModalContent from './OnboardingModalContent'
import CameraIcon from '@/assets/icons/camera.svg?inline'
import BottomActions from '~/components/onboarding/BottomActions'
import Button from '@/components/onboarding/Button'
import { MB } from '@/utils/uploadcare'
import OnboardingMixin from '@/components/onboarding/OnboardingMixin'

export default {
  components: {
    BottomActions,
    OnboardingModalContent,
    CameraIcon,
    Button,
  },
  mixins: [OnboardingMixin],
  computed: {
    ...mapState('onboarding', ['avatarUrlStored']),
  },
  methods: {
    updateProfilePicture() {
      this.$emit('saving')
      this.$axios
        .patch('/AUTH_URL/user', {
          avatar_url: this.avatarUrlStored,
        })
        .then((r) => {
          // This will cause a profile update.
          this.$store.dispatch('fiiAuth/refreshToken')

          this.$emit('next')
        })
    },
    openUploadCare() {
      this.$uploadcare
        .openDialog({ crop: '1:1', maxFileSize: 5 * MB }, this.$i18n)
        .done((result) => {
          result.done((fileInfo) => {
            this.$store.commit('onboarding/setAvatarUrl', fileInfo.cdnUrl)
          })
        })
    },
  },
}
</script>

<style scoped></style>
